// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Ruvd6JtM{gap:1rem;margin-bottom:1.94rem}@media(max-width:767.98px){.Ruvd6JtM{margin-bottom:1.5rem}}.Y4BMK5DV{gap:3rem}@media(max-width:767.98px){.Y4BMK5DV{gap:1rem}}.Y4BMK5DV a{align-items:center;display:flex;flex-wrap:nowrap;font-size:.88rem;gap:1.17em;line-height:1.39;white-space:nowrap}@media(max-width:991.98px){.Y4BMK5DV a{font-size:.81rem}}.Y4BMK5DV a svg{height:2.3em;width:auto}@media(max-width:991.98px){.Y4BMK5DV a svg{height:1.8em;height:1.5em}}.Y4BMK5DV a svg *{fill:currentColor}.GV9vMR8O{gap:1.44rem;margin-bottom:2rem}.AS4E8ilv{flex-grow:1}.fBjO7PuP{font-size:1rem;max-width:100%;width:31.25rem}.GbH-CHuM{color:#8a4d8d;height:1.2em;width:1.2em}.GbH-CHuM>*{fill:currentColor}.QpchOrYq{font-size:max(1rem,min(.94vw,1.13rem));margin-bottom:1.2em;max-width:80ch;padding-top:1.5em}.IEi2HSq0{border-radius:max(.84rem,min(1.25vw,1.5rem));display:block;margin-top:max(2.25rem,min(3.33vw,4rem));overflow:hidden;width:100%}.IEi2HSq0 img{height:auto;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"top": "Ruvd6JtM",
	"pdfs": "Y4BMK5DV",
	"filters": "GV9vMR8O",
	"search": "AS4E8ilv",
	"onboarding": "fBjO7PuP",
	"onboardingStar": "GbH-CHuM",
	"triplepointText": "QpchOrYq",
	"triplepointMap": "IEi2HSq0"
};
module.exports = ___CSS_LOADER_EXPORT___;
